import TabItem from './TabItem';

export { type TabItemProps } from './TabItem';
export default TabItem;
